import replace from './replace';

export default replace;
